module.exports = fox._r("images/bann-1.jpg", __webpack_public_path__ + "_/_/_/affiliate/images/bann-1.jpg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/affiliate/images/bann-1.jpg
// module id = 194
// module chunks = 4